import React from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="max-w-md mx-auto px-4 py-16 text-center">
        <XCircle size={64} className="mx-auto text-rose-500" />
        <h1 className="font-display text-3xl font-bold mt-4">Payment cancelled</h1>
        <p className="text-slate-600 mt-2">No worries — you can pay again from your booking.</p>
        <div className="mt-6"><Link to="/customer" className="btn-accent">Back to bookings</Link></div>
      </div>
    </div>
  );
}
